import type { RootState } from '@/store/root-reducer';

const selectInstitutionalsState = (state: RootState) => state.institutionals;

export const selectRows = (state: RootState) => selectInstitutionalsState(state).rows;
export const selectTotal = (state: RootState) => selectInstitutionalsState(state).total;
export const selectLoading = (state: RootState) => selectInstitutionalsState(state).loading;
export const selectError = (state: RootState) => selectInstitutionalsState(state).error;
export const selectPage = (state: RootState) => selectInstitutionalsState(state).page;
export const selectPageSize = (state: RootState) => selectInstitutionalsState(state).pageSize;
